import Divider from "@able/react/dist/Divider";
import { PropsWithChildren } from "react";
import DataFilters, { DataFilterProps } from "../../../DataFilters/DataFilters";
import { AbleCommonProps } from "../../../Types";

export type TableFiltersProps = AbleCommonProps & PropsWithChildren & DataFilterProps;

const TableFilters = (props: TableFiltersProps) => {
    return (
        <div className="ted-ui-TableFilters">
            <DataFilters {...props as DataFilterProps} />
            <Divider />
        </div>
    )
};

TableFilters.displayName = 'TableFilters';

export default TableFilters;